"use strict";
exports.__esModule = true;
exports.SuggestADateWeekendExperiment = exports.SuggestADateWeekendExperimentVariantValues = void 0;
var types_1 = require("../types");
var SuggestADateWeekendExperimentVariantValues;
(function (SuggestADateWeekendExperimentVariantValues) {
    SuggestADateWeekendExperimentVariantValues["Treatment"] = "treatment";
})(SuggestADateWeekendExperimentVariantValues = exports.SuggestADateWeekendExperimentVariantValues || (exports.SuggestADateWeekendExperimentVariantValues = {}));
exports.SuggestADateWeekendExperiment = {
    variantID: 'suggest-a-date-weekend-modal-feb-2025',
    controlValue: types_1.CONTROL,
    variantValues: SuggestADateWeekendExperimentVariantValues
};
